export default "__VITE_ASSET__f837de3a__"